/** BS-000003 / EMK-000003 (legacy) → «Клиент № 3» */
export function formatClientNumberLabel(raw) {
  if (!raw) return null;
  const text = String(raw).trim();
  const match = text.match(/^(?:BS|EMK)-(\d+)$/i);
  const digits = match ? match[1] : text.replace(/^(?:BS|EMK)-/i, "");
  const num = parseInt(digits, 10);
  if (!Number.isFinite(num) || num <= 0) return `№ ${text}`;
  return `Клиент № ${num}`;
}

export function formatClientNumberShort(raw) {
  return formatClientNumberLabel(raw) || null;
}

/** Карточка клиента или сырая строка → подпись для UI */
export function displayClientCardNumber(patientCardOrRaw) {
  if (!patientCardOrRaw) return "—";
  if (typeof patientCardOrRaw === "object") {
    if (patientCardOrRaw.card_number_display) {
      return patientCardOrRaw.card_number_display;
    }
    return formatClientNumberLabel(patientCardOrRaw.card_number) || "—";
  }
  return formatClientNumberLabel(patientCardOrRaw) || "—";
}
